/**
 * Short customer-facing order reference — first 8 chars of the OMS order id,
 * uppercased (e.g. "02995a1a-81cb-4077-923d-fac586b4feff" → "02995A1A").
 *
 * Mirrors eurosys-site/src/lib/orders/orderRef.ts shortOrderRef. The customer
 * sees this exact string in the builder confirmation and WhatsApp messages, so
 * the intranet must render the same ref for staff to correlate.
 */
export function orderShortRef(orderId?: string): string {
  if (!orderId) return "";
  return orderId.slice(0, 8).toUpperCase();
}
